import { createFileRoute } from '@tanstack/react-router'

import { TpvTcvPeaksScreen } from './-components/tpv-tcv-peaks-screen.tsx'

export const Route = createFileRoute('/business-performance/tpv-tcv-peaks')({
  component: TpvTcvPeaksScreen
})
